"use strict";var TCFCommand;Object.defineProperty(exports,"__esModule",{value:!0}),function(e){e.PING="ping",e.GET_TC_DATA="getTCData",e.GET_IN_APP_TC_DATA="getInAppTCData",e.GET_VENDOR_LIST="getVendorList",e.ADD_EVENT_LISTENER="addEventListener",e.REMOVE_EVENT_LISTENER="removeEventListener"}(TCFCommand=exports.TCFCommand||(exports.TCFCommand={}));


//////////////////
// WEBPACK FOOTER
// ../node_modules/@iabtcf/cmpapi/lib/command/TCFCommand.js
// module id = 33
// module chunks = 0